import './app';
import './views/live-toast';
import { watchChunks } from './chunk-reload';
import { flushOutbox, installDiag } from './diag';
import { initLanguage, syncLanguage, t } from './i18n';
import { mountDefaultNotice } from './research/default-notice';
import { ensureDrafts } from './drafts';
import { refreshLang } from './reminders';
import { go } from './router';
import { sweepShared } from './share-inbox';
import { confirmed, currentOwner, ensureSession, onSession } from './session';
import { forgetPendingLesson, observeResearchRoute, replay, research, startResearch } from './research-client';

// Owner-recorded research consent: a visible, dismissible notice with Stop, once per device.
mountDefaultNotice(research, () => ({
  text: t('research.defaultNotice'), textReplay: t('research.defaultNoticeReplay'),
  stop: t('research.defaultStop'), dismiss: t('research.defaultDismiss'),
}));
// A chunk of an older build that fails to load reloads the page once to the current one (never a black town).
watchChunks();
// Field signals (v1 ticket 43): errors and failed API calls, no content, sent unless the ⋯ menu's switch is off.
// Reports waiting on the device belong to whoever wrote them: they go once the server confirms that learner.
installDiag({ who: () => ({ owner: currentOwner(), confirmed: confirmed() }) });
onSession((state) => {
  replay.suspend();
  research.suspend(state.status === 'known' ? state.owner : null);
  forgetPendingLesson();
  if (confirmed()) {
    void startResearch();
    void flushOutbox();
    refreshLang();
  }
});
window.addEventListener('popstate', () => queueMicrotask(() => { void observeResearchRoute(); void replay.start(); }));

// Seed the interface language from the last known one (no flash of English),
// then confirm it against the signed-in learner's pair.
initLanguage();
void syncLanguage();

// A voice message shared to Eaves that nobody came for goes once it is stale.
void sweepShared();

// Device drafts follow whoever is signed in: list and send theirs only.
ensureDrafts();
ensureSession();

// In beta, news from a friend (an army at the gates, a raid back) shows over the screens that would hide it (live-toast.ts).
document.body.appendChild(document.createElement('live-toast'));

// A tapped reminder tells the open page where to go, rather than reloading it (reminders-sw.ts).
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (e: MessageEvent) => {
    const d = e.data as { type?: string; url?: unknown } | null;
    if (d?.type !== 'reminder-open' || typeof d.url !== 'string') return;
    if (!d.url.startsWith('/') || d.url.startsWith('//') || d.url.startsWith('/\\')) return;
    go(d.url);
  });
}

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
